module.exports = __webpack_public_path__ + "static/when-nietzsche-wept-b4c301a6a72e9a68c89063dc4342f1fe.jpg";